import { Children, isValidElement, useState, type ReactElement, type ReactNode } from "react";

function isTab(node: ReactNode): node is ReactElement<{ children?: ReactNode; label?: string }> {
  return isValidElement(node) && (node as ReactElement).type === Tab;
}

export function Tab({ children }: { children?: ReactNode; label?: string }) {
  return <>{children}</>;
}

export function Tabs({
  items,
  children,
}: {
  items?: string[];
  children?: ReactNode;
}) {
  const tabs = Children.toArray(children).filter(isTab);
  const labels = items && items.length > 0 ? items : tabs.map((_, i) => `Tab ${i + 1}`);
  const [active, setActive] = useState(0);
  const current = Math.min(active, tabs.length - 1);
  return (
    <div className="my-4">
      <div role="tablist" aria-label="Examples" className="flex gap-1 border-b border-border">
        {labels.map((label, i) => (
          <button
            key={label + i}
            role="tab"
            aria-selected={i === current}
            onClick={() => setActive(i)}
            className={
              "px-3 py-1.5 text-sm font-medium rounded-t-md " +
              (i === current
                ? "border border-b-0 border-border bg-card text-foreground"
                : "text-muted-foreground hover:text-foreground")
            }
          >
            {label}
          </button>
        ))}
      </div>
      <div role="tabpanel">{tabs[current]}</div>
    </div>
  );
}